import type { Schema } from '../../../../Entities/Schema.entity';
import { createSchema } from '../../../../Utils/CreateSchema';

export const legitimateInterestsSchema: Schema = {
  ...createSchema({
    version: '1-2-0',
    description: 'Legitimate interests given features',
    name: 'legitimate_interests',
    properties: {
      features: {
        type: 'object',
        description: 'List of legitimate interests features',
      },
    },
  }),
};
